export default function DocumentLink({ href, children = "View Document" }) {
  return (
    <a
      className="doc-link"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
}
